import { getXPartner } from "@/app/utils/helper";

const requestHeaders: Record<string, string> = {
    "X-partner": getXPartner(),
};

const requestOptions: RequestInit = {
    headers: requestHeaders,
};

/** Default FAQ category for pages that omit props (e.g. homepage). */
export const FAQ_DEFAULT_PRODUCT = "others";
/** Default FAQ path segment for generic listing FAQs. */
export const FAQ_DEFAULT_SUB_PRODUCT = "generic";

export function resolveFaqParams(product?: string, subProduct?: string) {
    return {
        product: product ?? FAQ_DEFAULT_PRODUCT,
        subProduct: subProduct ?? FAQ_DEFAULT_SUB_PRODUCT,
    };
}

/**
 * Fetches FAQ data from a URL derived only from product (productType query) and subProduct (path).
 *
 * Examples:
 * - others + generic  → /faqs/generic?productType=others (API_BASE_URL)
 * - fd + generic      → /faqs/generic?productType=fd (API_STOCKS_URL)
 * - bonds + referral  → /faqs/referral?productType=bonds
 * - unlistedEquities + NSE01 → /faqs/NSE01?productType=unlistedEquities
 * - calculator + {id} → /faqs/{id}?productType=calculator (API_BASE_URL)
 */
export async function fetchFaqData(product?: string, subProduct?: string) {
    const { product: resolvedProduct, subProduct: resolvedSubProduct } = resolveFaqParams(
        product,
        subProduct,
    );

    const API_BASE_URL = process.env.API_BASE_URL;
    const API_STOCKS_URL = process.env.API_STOCKS_URL;

    let url: string | null = null;

    if (resolvedProduct === "others" && resolvedSubProduct === "generic") {
        if (!API_BASE_URL) {
            console.warn("API_BASE_URL is not defined, skipping FAQ fetch");
            return null;
        }
        url = `${API_BASE_URL}/faqs/generic?productType=others`;
    } else {
        if (!API_STOCKS_URL) {
            console.warn("API_STOCKS_URL is not defined, skipping FAQ fetch");
            return null;
        }
        url = `${API_STOCKS_URL}/faqs/${resolvedSubProduct}?productType=${resolvedProduct}`;
    }

    try {
        const response = await fetch(url, requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (err) {
        console.error("Error fetching FAQ data:", err);
        return err;
    }
}
